export default __webpack_public_path__ + "static/media/alin-cohen.c8cd0dda.png";